module.exports = __webpack_public_path__ + "img/painel_img1.79ac8dad.png";